// extracted by mini-css-extract-plugin
module.exports = {"placeholderImage":"PlaceholderImage_placeholderImage__Rf62L"};